import * as types from "./types";

export default {
  [types.SET_TAXCODELIST](state, payload) {
    state.taxcodeList = payload;
  },
  [types.SET_TAXCODEOBJECT](state, payload) {
    state.currentTaxcodeObject = payload;
  }
};
